import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { Trans } from 'next-i18next';
import aiduLogo from '../../../../assets/images/trustElement/aiduLogo.svg';
import fluegeLogo from '../../../../assets/images/trustElement/fluegeLogo.svg';
import inviaLogo from '../../../../assets/images/trustElement/inviaLogo.svg';
import travelPlanetLogo from '../../../../assets/images/trustElement/travelPlanetLogo.svg';
import { Container } from '../../../../components/Footer/components/TrustElement/components/Container.js';
import { ImageGroup } from '../../../../components/Footer/components/TrustElement/components/ImageGroup.js';
import { Lead } from '../../../../components/Footer/components/TrustElement/components/Lead.js';
import { MaskedLink } from '../../../../components/internal/MaskedLink/index.js';
import { NextImage } from '../../../../components/internal/NextImage/index.js';
import { Block, LabelMediumBold, LabelSmallBold, Link } from '../../../../primitives/index.js';
import { SPACING_LARGE, SPACING_XLARGE } from '../../../../utils/spacingLegacy.js';
export const TrustElement = () => {
  const xlUp = useBreakpointUp('xl');
  const LabelBoldComponent = xlUp ? LabelMediumBold : LabelSmallBold;
  return _jsxs(Container, {
    justifyContent: "space-between",
    alignItems: "center",
    direction: xlUp ? 'row' : 'column-reverse',
    spacing: SPACING_XLARGE,
    children: [_jsx(Lead, {
      color: "contentInversePrimary",
      children: _jsx(Trans, {
        ns: "footer",
        i18nKey: "trustElementText",
        components: {
          b: _jsx(LabelBoldComponent, {
            as: Link,
            // @ts-expect-error TS2322
            href: "https://www.invia.com/",
            color: "contentInversePrimary"
          })
        }
      })
    }), _jsxs(ImageGroup, {
      justifyContent: "center",
      direction: "row",
      flexWrap: "wrap",
      spacing: xlUp ? 3 : SPACING_LARGE,
      children: [_jsx(MaskedLink, {
        href: "https://www.ab-in-den-urlaub.de/magazin/reisebuero/",
        target: "_blank",
        children: _jsx(Block, {
          children: _jsx(NextImage, {
            width: xlUp ? 158 : 105,
            height: xlUp ? 36 : 24,
            image: aiduLogo
          })
        })
      }), _jsx(MaskedLink, {
        href: "https://www.fluege.de/",
        target: "_blank",
        children: _jsx(Block, {
          children: _jsx(NextImage, {
            width: xlUp ? 143 : 105,
            height: xlUp ? 36 : 24,
            image: fluegeLogo
          })
        })
      }), _jsx(MaskedLink, {
        href: "https://www.invia.de/",
        target: "_blank",
        children: _jsx(Block, {
          children: _jsx(NextImage, {
            width: xlUp ? 90 : 60,
            height: xlUp ? 36 : 24,
            image: inviaLogo
          })
        })
      }), _jsx(MaskedLink, {
        href: "https://www.travelplanet.pl/",
        target: "_blank",
        children: _jsx(Block, {
          children: _jsx(NextImage, {
            width: xlUp ? 170 : 112,
            height: xlUp ? 36 : 24,
            image: travelPlanetLogo
          })
        })
      })]
    })]
  });
};